import React from "react";
import "./Franchise.scss"
import { sortByOrderAscending } from "../../../../Hospitality/helper/helper";
const FranchiseHero = ({ components }) => {
    const getComponents = (component) => {
        switch (component.ID) {
            case "hero-header":
                return <div className="Franchise-hero-content-header">
                    {component?.Props?.content}
                </div>
            case "hero-subheader":
                return <div className="Franchise-hero-content-subheader">
                    {component?.Props?.content}
                </div>
            case "hero-button":
                return <div className="Franchise-hero-btn" onClick={() => {
                    document.getElementById("form-container").scrollIntoView({ behavior: "smooth" });
                }}>
                    {component?.Props?.buttonText}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="Franchise-hero" style={{
            background: `linear-gradient(90deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%), url(${components[0]?.Props?.src}) center / cover no-repeat`,
        }
        }>
            < div className="Franchise-hero-content" >

                {sortByOrderAscending(components).map((component) => {
                    return getComponents(component)
                })}

            </div >
        </div >
    )
}
export default FranchiseHero